/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, formatNumber, CTicksToDateString, CTicksToDateStringRemainTime } from '../Utility.js';

import Title from './Title.js';

function Member() {

  const state=useSelector((state)=>state);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [SearchString, setSearchString] = useState('');
  const [contentView, setContentView] = useState(0); // 드롭다운 보임/숨김 상태
  const [searchItem, setSearchItem] = useState("아이디"); // 선택된 드롭다운 항목
  const [pageIndex, setpageIndex] = useState(0); // 선택된 드롭다운 항목
  const [totalCount, setTotalCount] = useState(0); // 선택된 드롭다운 항목
  const [viewIndex, setviewIndex] = useState(0); // 선택된 드롭다운 항목
  const [recommandPoint, setRecomandPoint ]= useState(0);
  const [registerPoint, setRegisterPoint ]= useState(0);
  
  const dropdown = () => {
    setContentView((prev) => (prev === 0 ? 1 : 0)); // 열기/닫기 토글
  };

  const getSearchItem = () => searchItem;

  const setSerarchItem = (item) => {
    const items = ["아이디", "닉네임", "이름"];
    setSearchItem(items[item]);
    setContentView(0); // 항목 선택 시 드롭다운 닫기
  };

  function Search()
  {
    if(SearchString === '')
    {
        return;
    }
  }

  function Refresh()
  {
    if(state.Request === 1)
    {
        return;
    }

    setTotalCount(0);
    setpageIndex(0);
    setviewIndex(1);
    RequestAllUserSearch(1);
  }

  function GetPageNumber(number)
  {
    return (pageIndex * 10) + number;
  }

  function NextPage()
  {
    if(totalCount === 0)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(viewIndex === maxIndex)
    {
        return;
    }

    var newViewIndex = viewIndex + 1;
    ClickViewIndex(newViewIndex);  
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function PrevPage()
  {
    if(totalCount === 0 ||
        viewIndex === 1)
    {
        return;
    }

    var newViewIndex = viewIndex - 1;
    ClickViewIndex(newViewIndex);
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function ClickViewIndex(index)
  {
    if(totalCount === 0)
    {
        return;
    }
    
    if(state.Request === 1)
    {
        return;
    }
    
    if(viewIndex === index)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(maxIndex < index)
    {
        return;
    }

    setviewIndex(index);
    RequestAllUserSearch(index);
  }

  const RequestAllUserSearch = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
              alert('유저 정보 만료(다시 로그인 해주세요)');  
              navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
              return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AllUserSearch', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 15}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateMemberArray', Log:data.user_data_array});  
                    setTotalCount(data.total_count);
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);
    
                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    const RequestEditRecommandPoint = async (e) => 
        {
            e.preventDefault();
            try
            {
                if(state.Request === 1)
                {
                    return;
                }

                if(state.Recommand_Point === recommandPoint)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Admin/AdminEditRecommandPoint', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, point : recommandPoint}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateRecommandPoint', Value:recommandPoint});  
                        
                        alert('추천천 포인트 적용 완료 ' + recommandPoint + 'P');
                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };

    const RequestEditRegisterPoint = async (e) => 
        {
            e.preventDefault();
            try
            {
                if(state.Request === 1)
                {
                    return;
                }

                if(state.Register_Point === registerPoint)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                    return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Admin/AdminEditRegisterPoint', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, point : registerPoint}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateRegisterPoint', Value:registerPoint});  
                        alert('가입 포인트 적용 완료 ' + registerPoint + 'P');  
                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                        var startTime = CTicksToDateString(data.start_time);
                        var endTime = CTicksToDateString(data.end_time);
        
                        var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                        alert(message);  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };
    
    if(state.MemberFirstRender === false)
    {
        dispatch({type:'MemberFirstRender'});
        setTotalCount(0);
        setpageIndex(0);
        setviewIndex(1);
        RequestAllUserSearch(1);
        setRecomandPoint(state.Recommand_Point);
        setRegisterPoint(state.Register_Point);
    }

    function GetNumber(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return state.MemberArray[index].user_no;
    }

    function GetID(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return state.MemberArray[index].email;
    }

    function GetNickName(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return state.MemberArray[index].nickname;
    }

    function GetName(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return state.MemberArray[index].name;
    }

    function GetPoint(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return formatNumber(state.MemberArray[index].point) + 'P';
    }

    function GetRemainTime(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return CTicksToDateStringRemainTime(state.MemberArray[index].remain_time)
    }

    function GetTicketCount(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return formatNumber(state.MemberArray[index].time_ticket_count) + '개';
    }

    function GetRegisterTime(index)
    {
        if(state.MemberArray === undefined || state.MemberArray.length <= index)
        {
            return'';
        }

        return CTicksToDateString(state.MemberArray[index].create_at_time);
    }
    const closeWriteModalType = () => {
        dispatch({type:'UpdateWriteModal', View:false, Type:0});
      }

  return (
    <div id='Player_Range'>
        <Title DisplayType="0"></Title>
        <div className='search-box'>
            <div className='dropdown_parent'>
                <div className="dropdown-label">검색 조건</div>
                <div className="dropdown">
                    <button className="dropbtn">
                    <span className="dropbtn_icon">more_horiz</span>
                    <span className="dropbtn_content">{getSearchItem()}</span>
                    <span
                        className="dropbtn_click"
                        style={{
                        fontFamily: "Material Icons",
                        fontSize: "16px",
                        color: "#3b3b3b",
                        float: "right",
                        }}
                        onClick={dropdown}
                    >
                        arrow_drop_down
                    </span>
                    </button>
                    <div
                    className="dropdown-content"
                    style={{ display: contentView === 0 ? "none" : "block" }}
                    >
                    <div className="fastfood" onClick={() => setSerarchItem(0)}>
                        아이디
                    </div>
                    <div className="fastfood" onClick={() => setSerarchItem(1)}>
                        닉네임
                    </div>
                    <div className="fastfood" onClick={() => setSerarchItem(2)}>
                        이름
                    </div>
                    </div>
                </div>
            </div>
            <input
                type="search"
                placeholder="검색 입력"
                value={SearchString}
                onChange={(e) => setSearchString(e.target.value)}
            />
            <div className='search_button' onClick={() => Search()}>검색</div>
            <div className='search_button' onClick={() => Refresh()}>최신목록</div>
            <div className="register-point-label">가입 포인트</div>
            <input
                type="search"
                class="register-point-text"
                placeholder="숫자 입력"
                value={registerPoint}
                onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, ""); // 숫자만 허용
                    setRegisterPoint(onlyNumbers);
                }}
            />
            <div className='register-point-button' onClick={RequestEditRegisterPoint}>갱신</div>
            <div className="recommand-point-label">추천인 포인트</div>
            <input
                type="search"
                class="recommand-point-text"
                placeholder="숫자 입력"
                value={recommandPoint}
                onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, ""); // 숫자만 허용
                    setRecomandPoint(onlyNumbers);
                }}
            />
            <div className='recommand-point-button' onClick={RequestEditRecommandPoint}>갱신</div>
            <div className='total_count'><h2>총 유저수 : {formatNumber(totalCount)}명</h2></div>
        </div>
        <div className='member-box'>
            <div className='member-box-table'>
                <tr>
                    <th style={{width:"5%"}}>넘버</th>
                    <th style={{width:"15%"}}>아이디</th>
                    <th style={{width:"15%"}}>닉네임</th>
                    <th style={{width:"15%"}}>이름</th>
                    <th style={{width:"15%"}}>포인트</th>
                    <th style={{width:"15%"}}>남은 시간</th>
                    <th style={{width:"10%"}}>시간 권</th>
                    <th style={{width:"20%"}}>가입 일시</th>
                </tr>
                {Array.from({length:15}).map((_, index)=>(
                    <tr>
                        <td style={{textAlign:"center"}}>{GetNumber(index)}</td>
                        <td style={{textAlign:"center"}}>{GetID(index)}</td>
                        <td style={{textAlign:"center"}}>{GetNickName(index)}</td>
                        <td style={{textAlign:"center"}}>{GetName(index)}</td>
                        <td style={{textAlign:"center"}}>{GetPoint(index)}</td>
                        <td style={{textAlign:"center"}}>{GetRemainTime(index)}</td>
                        <td style={{textAlign:"center"}}>{GetTicketCount(index)}</td>
                        <td style={{textAlign:"center"}}>{GetRegisterTime(index)}</td>
                    </tr>
                ))}
            </div>
            <div className='member-box-count-box'>
                <div className='member-box-count' onClick={() => PrevPage()}><h2>{"<"}이전</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(1))}><h2>{GetPageNumber(1)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(2))}><h2>{GetPageNumber(2)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(3))}><h2>{GetPageNumber(3)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(4))}><h2>{GetPageNumber(4)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(5))}><h2>{GetPageNumber(5)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(6))}><h2>{GetPageNumber(6)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(7))}><h2>{GetPageNumber(7)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(8))}><h2>{GetPageNumber(8)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(9))}><h2>{GetPageNumber(9)}</h2></div>
                <div className='member-box-count' onClick={() => ClickViewIndex(GetPageNumber(10))}><h2>{GetPageNumber(10)}</h2></div>
                <div className='member-box-count' onClick={() => NextPage()}><h2>다음{">"}</h2></div>
            </div>
        </div>
    </div>
  );
}

export default Member;